// extracted by mini-css-extract-plugin
module.exports = {"groupTitle":"styles_groupTitle__jFujW","title":"styles_title__zv0nz"};